import CryptoJS from 'crypto-js';

export class LocalStorageService {
    setToken(tokenObj) {
        if(tokenObj.refreshToken !== null){
            localStorage.setItem("access_token", tokenObj.token);
            localStorage.setItem("refresh_token", tokenObj.refreshToken);
            localStorage.setItem("userLogin", JSON.stringify(tokenObj));
        }else{
            localStorage.setItem("userReset", JSON.stringify(tokenObj));
        }
    }

    setAccessRefreshRefresToken (tokenObj) {
        localStorage.setItem("access_token", tokenObj.token);
        localStorage.setItem("refresh_token", tokenObj.refreshToken);
    }

    getRefreshToken() {
        return localStorage.getItem("refresh_token");
    }

    getAccessToken() {
        return localStorage.getItem("access_token");
    }

    getUserLogin() {
        return JSON.parse(localStorage.getItem("userLogin"));
    }

    getUserReset() {
        return JSON.parse(localStorage.getItem("userReset"));
    }

    encrypt(word){
          const keyBase64 = "o9szYIOq1rRMiouNhNvaq96lqUvCekxR";
          var key = CryptoJS.enc.Base64.parse(keyBase64);
          var srcs = CryptoJS.enc.Utf8.parse(word);
          var encrypted = CryptoJS.AES.encrypt(srcs, key, {mode:CryptoJS.mode.ECB,padding: CryptoJS.pad.Pkcs7});
          return encrypted.toString();
    }

    clearResetPassword(){
        localStorage.removeItem("userReset");
        localStorage.removeItem("code");
    }

    getRolFromToken() {
        try {
            const token = this.getAccessToken();
            if (!token) return null;
            const payload = JSON.parse(atob(token.split('.')[1]));
            return payload?.data?.rol || null;
        } catch {
            return null;
        }
    }

    clearToken() {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("userLogin");
        localStorage.removeItem("userReset");
        localStorage.removeItem("code");
    }
}
